import { render, staticRenderFns } from "./Terminated.vue?vue&type=template&id=1634676b&"
import script from "./Terminated.vue?vue&type=script&lang=js&"
export * from "./Terminated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports